import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface getAllNotiByType {
  message: string,
  result: [
    {
      ID: string,
      CREATE_DATE: Date,
      NOTI_DETAIL: string,
      NOTI_GROUP: string,
      NOTI_ID: string,
      NOTI_STATUS: number,
      NOTI_TITLE: string,
      SEND_TO: string,
      LINK: string
    }
  ],
  success: boolean
}

interface resGetAllNotificationByUser {
  message: string,
  result: [
    {
      ID: string,
      CREATE_DATE: Date,
      NOTI_DETAIL: string,
      NOTI_GROUP: string,
      NOTI_ID: string,
      NOTI_STATUS: number,
      NOTI_TITLE: string,
      SEND_TO: string,
      LINK: string
    }
  ],
  success: boolean
}

interface resUpdateStatusNoti {
  message: string,
  result:
  {
    ID: [string],
  },
  success: boolean
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.token = this.authService.getToken();

    if (!this.token) {
      this.token = environment.KEY;
    }
  }

  getAllNotificationByUser() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetAllNotificationByUser>(environment.URL + '/notification/getAllNotificationByUser', { headers: headers });
  }

  updateStatusNoti(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resUpdateStatusNoti>(environment.URL + '/notification/updateStatusNoti', body, { headers: headers });
  }

  getAllNotiByType(type: number) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<getAllNotiByType>(environment.URL + '/notification/getAllNotiByType?TYPE=' + type, { headers: headers });
  }
}
